export default __webpack_public_path__ + "static/media/background.0ee1659d.png";